import { render, staticRenderFns } from "./FigurasTransportes.vue?vue&type=template&id=3c3696a2&scoped=true&"
import script from "./FigurasTransportes.vue?vue&type=script&lang=js&"
export * from "./FigurasTransportes.vue?vue&type=script&lang=js&"
import style0 from "./FigurasTransportes.vue?vue&type=style&index=0&id=3c3696a2&lang=scss&scoped=true&"
import style1 from "./FigurasTransportes.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3696a2",
  null
  
)

export default component.exports